import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
// pages for this kit
import HomePage from '../views/home';
import SearchPage from '../views/search';
import ProductPage from '../views/product';
import CartPage from '../views/cart';
import CheckoutPage from '../views/checkout';
import PaymentRespSuccess from '../views/payment-resp/success';
import PaymentRespFailure from '../views/payment-resp/failure';
import PaymentRespCelled from '../views/payment-resp/cancelled';
import NotFoundPage from '../views/notfound';
import UserAddress from '../views/user/address';
import UserPurchase from '../views/user/purchase';
import UserReturn from '../views/user/return';
import UserVoucher from '../views/user/voucher';
import UserReturnOrder from '../views/user/returnOrder';
import Category from '../views/categories';
import AboutUs from '../views/about-us';
import Branches from '../views/branches';
import HowToBuy from '../views/how-to-buy';

const Routing = ({ location, history }) => {
  const { basename, items } = routeConfig;
  const { pathname } = location;
  if (pathname.slice(1, 3) == 'th') history.push(pathname.slice(3));
  return (
    <Switch>
      {items.map((item, index) => (
        <Route
          key={index}
          exact
          path={`${basename}/${item.path}`}
          {...item.props}
        />
      ))}
      <Route component={NotFoundPage} />
    </Switch>
  );
};

const routeConfig = {
  basename: '/:lng(en|th)?',
  items: [
    {
      path: '',
      props: {
        render: (props) => <HomePage {...props} />
      }
    },
    {
      path: 'search',
      props: {
        render: (props) => <SearchPage {...props} />
      }
    },
    {
      path: 'cart',
      props: {
        render: (props) => <CartPage {...props} />
      }
    },
    {
      path: 'checkout',
      props: {
        render: (props) => <CheckoutPage {...props} />
      }
    },
    {
      path: 'paymentsuccess',
      props: {
        render: (props) => <PaymentRespSuccess {...props} />
      }
    },
    {
      path: 'paymentfailure',
      props: {
        render: (props) => <PaymentRespFailure {...props} />
      }
    },
    {
      path: 'paymentcancelled',
      props: {
        render: (props) => <PaymentRespCelled {...props} />
      }
    },
    {
      path: 'about-us',
      props: {
        render: (props) => <AboutUs />
      }
    },
    {
      path: 'branches',
      props: {
        render: (props) => <Branches />
      }
    },
    {
      path: 'how-to-buy',
      props: {
        render: (props) => <HowToBuy />
      }
    },
    {
      path: ':categoryName',
      props: {
        render: (props) => <Category {...props} />
      }
    },
    {
      path: ':type(product|voucher)/:name',
      props: {
        render: (props) => (
          <ProductPage {...props} type={props.match.params.type} />
        )
      }
    },
    {
      path: 'user/purchase',
      props: {
        render: (props) => <UserPurchase {...props} />
      }
    },
    {
      path: 'user/purchase/:invoice',
      props: {
        render: (props) => <UserPurchase {...props} />
      }
    },
    {
      path: 'user/address',
      props: {
        component: PrivateRoute(UserAddress)
      }
    },
    {
      path: 'user/return',
      props: {
        component: PrivateRoute(UserReturn)
      }
    },
    {
      path: 'user/voucher',
      props: {
        component: PrivateRoute(UserVoucher)
      }
    },
    {
      path: 'user/returnorder/:orderid',
      props: {
        component: PrivateRoute(UserReturnOrder)
      }
    }
  ]
};

export default withRouter(Routing);
